<template>
    <div class="sustainability-r">
        <h4>CSR (Corporate social responsibility)</h4>
        <p class="indent">Alcomet’s commitment to the welfare of its employees and society as a whole, together with its large-scale charitable activities and active environmental policy are a significant part of the company’s corporate social responsibility efforts. Some of the company’s goals related to corporate social responsibility are providing employment to the local community; effectively supporting educational, medical, cultural and other institutions; working with charity and donation organizations. In 2022 Alcomet was awarded the Charitable Giver of the Year Prize by the Municipality of the town of Shumen. </p>
      <p> <a href="/static/files/sustainability/Sustainability-policy-2025.pdf" target="_blank">Sustainability policy</a> </p>
      <p><a href="/static/files/sustainability/social-responsibility-policy.pdf" target="_blank">Social responsibility policy </a></p>
        <p><a href="/static/files/Regulations_for_business_conduct_and_ethics.pdf" target="_blank">Regulations for business conduct and ethics</a></p>
        <p><a href="/static/files/Anti-bribery-and-corruption-policy_b102020.pdf" target="_blank">Anti-bribery and corruption procedure policy</a></p>
        <p><a href="/static/files/Complaint-management-policy_b_102020.pdf" target="_blank">Complaint management procedure policy</a></p>
        <p><a href="/static/files/suppliers-code-of-conduct.pdf" target="_blank">Suppliers’ Code of Conduct </a></p>
        <p><a href="/static/files/Alcomet_action_plan_2511261.pdf" target="_blank">Action plan for reducing GHG emissions </a></p>

        <!--
        <p><a href="/static/files/Policy-b-Anti-bribery-and-corruption.pdf" target="_blank">Anti-bribery and corruption policy</a> </p>
        <p><a href="/static/files/Policy-b-Complaint-management.pdf" target="_blank">Complaint management policy</a></p>
        <p><a href="/static/files/Policy-Code-of-conduct.pdf" target="_blank">Code of conduct</a></p>
        <p><a href="/static/files/suppliers-code-of-conduct.pdf" target="_blank">Suppliers’ Code of Conduct</a></p>
        <p><a href="/static/files/Policy_Soc-Resp.pdf" target="_blank">Policy for Social Responsibility</a></p>
        <p><a href="/static/files/A-POLICY-REGARDING-CHILD-LABOUR-1.pdf" target="_blank">Policy regarding child labour</a></p>
        -->
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import Sustainability from "../Sustainability.vue";
import Reports from "../download-center/Reports.vue";
export default {
  components: {
    Reports,
    Sustainability,
    appShareButton: ShareButton
  }
};
</script>

<style scoped>

.sustainability-r > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .sustainability-r {
    padding-bottom: 20px;
  }
  .sustainability-r > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sustainability/Responsibility.vue